var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInactiveContractIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.2668 7.9999 1.6-1.6c0.1333-0.13333 0.1333-0.33333 0-0.46667l-0.7334-0.73333c-0.1333-0.13333-0.33329-0.13333-0.46662 0l-1.6667 1.5333-1.6-1.6c-0.13333-0.13333-0.33333-0.13333-0.46666 0l-0.8 0.73334c-0.13334 0.13333-0.13334 0.33333 0 0.46666l1.6 1.6667-1.6 1.6c-0.13334 0.13333-0.13334 0.33333 0 0.46663l0.73333 0.7334c0.13333 0.1333 0.33333 0.1333 0.46667 0l1.6-1.6 1.6 1.6c0.13333 0.1333 0.33333 0.1333 0.46665 0l0.7333-0.7334c0.1334-0.1333 0.1334-0.3333 0-0.46663l-1.4666-1.6z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveContractIcon);
export default __webpack_public_path__ + "static/media/inactiveContractIcon.b83a6c9cbbbf1b01cebb9e55f7fbcdf2.svg";
export { ForwardRef as ReactComponent };